"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.propTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var propTypes = {
  Native: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  Email: _propTypes["default"].shape({
    subject: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  Facebook: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    text: _propTypes["default"].string
  }),
  Twitter: _propTypes["default"].shape({
    url: _propTypes["default"].string,
    text: _propTypes["default"].string
  })
}; // eslint-disable-next-line import/prefer-default-export

exports.propTypes = propTypes;